import { useSelector } from "react-redux";
import { Message } from "semantic-ui-react";
import { AppState } from "../../store/configureStore";

export const AppInfoMessage = () => {
    const { queuedTimestamps, availableWorkers } = useSelector((state: AppState) => state.appInfo);

    const displayQueuedTimestamps = queuedTimestamps > 999 ? "999+" : queuedTimestamps;

    return (
        <Message id ="message-appInfoMessage" className="app-info-message" floating compact>
            <p id ="p-queued-timestamps-appInfoMessage" > Queued timestamps:&nbsp;{displayQueuedTimestamps}</p>
            <p id="p-available-workers-appInfoMessage">Available workers:&nbsp;{availableWorkers}</p>
        </Message>
    );
};
